import { RepeatActivity } from "@/enum/activity";
import { NavsClickNewType } from "@/enum/component";
import { gclassEnum } from "@/enum/game";
import { ActivityTypeEnum } from "@/types/compontent/base/baseEnum";

export const APP_ID = Number(import.meta.env.VITE_APP_APPID);
export const SERVER_URL = import.meta.env.VITE_SERVER_URL;
export const APP_LANG = import.meta.env.VITE_APP_LANG;
export const APP_SKIN = import.meta.env.VITE_APP_SKIN;
export const POINT_TYPE = Number(import.meta.env.VITE_POINT_TYPE);
export const PHONE_CODE = `${import.meta.env.VITE_PHONE_CODE}`;
export const POINT_RATIO = Number(import.meta.env.VITE_POINT_RATIO);
export const CURRENCY_NAME = import.meta.env.VITE_CURRENCY_NAME;
export const CURRENCY_SYMBOL = import.meta.env.VITE_CURRENCY_SYMBOL;
export const HOTJAR_ID = import.meta.env.VITE_HOTJAR_ID;
export const STATIC_FILE = import.meta.env.VITE_STATIC_FILE;
export const ACTIVITY_HOST = import.meta.env.VITE_ACTIVITY_HOST;
export const APP_NAME = import.meta.env.VITE_APP_NAME || "afun";

export const LocalStorageKey = {
  TOKEN: "Token",
  IS_LOGIN: "is_login",
  USER_ID: "user_id",
  USER_STORE: "user_store",
  HELLO: "hello",
  PUSH_MSG: "push_msg",
  I18_KEY_LANG: "i18KeyLng2",
  REMEMBER_ME: "rememberMe",
  //上次登录的时间【包含自动登录】
  LastLoginTime: "LastLoginTime",
  ClientDevice: "ClientDevice",
  LastLoginEventTime: "LastLoginEventTime",
  MyPageParams: "my_page_params",
  LOGIN_TYPE: "login_type",
  // 线下活动详情
  OFFLINE_ACTIVITY_DETAILS: "offline_activity_details",
  // 线下活动store
  PROMOTIONS_STORE: "promotions_store",
  LastChannel: "LastChannel",
  FacebookInit: "FacebookInit",
  IsPWAFirstOpen: "IsPWAFirstOpen",
  TwaInit: "TwaInit",
  FIRST_THINKINGDATA: "FIRST_THINKINGDATA",
  ConfigVersionHistory: "ConfigVersionHistory",
  SubscriptionInfo: "sk_s_p_i",
  RCSEntryTime: "rcs_entry_time",
  CurrentReceiveRewardTaskId: "CurrentReceiveRewardTaskId",
} as const;

export const CookieKey = {
  TIKTOK_TTP: "_ttp",
  TIKTOK_CLID: "ttclid",
  FB_FBC: "_fbc",
  FB_FBP: "_fbp",
} as const;

export const SessionStorageKey = {
  Buoy: "Buoy",
} as const;

export const StorageType = {
  Local: "local",
  Session: "session",
} as const;

export type TLocalStorageKey = keyof typeof LocalStorageKey;

export const RouterTypeEnum = {
  Login: "login",
};
export type TRouterTypeEnum = keyof typeof RouterTypeEnum;

export type TDeviceType = "PC" | "H5";

export const newComerActList = [
  ActivityTypeEnum.superValueGiftBox,
  ActivityTypeEnum.reliefFund3,
  ActivityTypeEnum.newCheckIn,
  ActivityTypeEnum.newbieWheel,
  ActivityTypeEnum.sevenNewTask,
  ActivityTypeEnum.firstDeposit,
  ActivityTypeEnum.appdownload,
  ActivityTypeEnum.dailyLossBack, // 新用户日亏损返现
  ActivityTypeEnum.dailyCashbackExperience,
];

export const wagerContestActList = [
  ActivityTypeEnum.wagerContestDay,
  ActivityTypeEnum.wagerContestWeek,
  ActivityTypeEnum.wagerContestMonth,
  ActivityTypeEnum.wagerContestDayCasino,
  ActivityTypeEnum.wagerContestDaySport,
  ActivityTypeEnum.wagerContestWeekCasino,
  ActivityTypeEnum.wagerContestWeekSport,
  ActivityTypeEnum.wagerContestMonthCasino,
  ActivityTypeEnum.wagerContestMonthSport,
];

export const categoryList = [200, 20, 25, 27, 31, 42, 62, 76, 83];

export const NormalActList = [
  ActivityTypeEnum.gachapon,
  ActivityTypeEnum.propsItem,
  ActivityTypeEnum.wagerContest,
  ActivityTypeEnum.roulette,
  ActivityTypeEnum.dailyLossRebate,
  ActivityTypeEnum.flipCard,
  ActivityTypeEnum.vipWeeklyCard, // 超值七日卡
  ActivityTypeEnum.shakeRedPacket, // 每日首充活动
  ActivityTypeEnum.cashFlop, // 邀请转盘活动
  RepeatActivity.RepeatCompetition, // 优惠活动竞标赛
];

export const VipActList = [
  ActivityTypeEnum.vipUpgrade, // 升级奖励
  ActivityTypeEnum.vipRebate, // 投注返现
  ActivityTypeEnum.vipLossRebate, // 亏损返现
  ActivityTypeEnum.weeklyRebate, //周体育返利
  ActivityTypeEnum.vipMonthBonus, // 月奖金
  ActivityTypeEnum.vipWeekly, // 周奖金
  ActivityTypeEnum.vipDayDeposit, // 每日首充活动
];

export const vipRulesList = [
  ActivityTypeEnum.vipUpgrade, // 升级奖励
  ActivityTypeEnum.vipRebate, // 投注返现
  ActivityTypeEnum.vipDayBonus, // 日奖金
  // ActivityTypeEnum.weeklyRebate, // 周体育投注返利
  ActivityTypeEnum.vipLossRebate, // 亏损返现
  // ActivityTypeEnum.vipWeekly, // 周奖金
  ActivityTypeEnum.vipWeeklyRebate, // 周返现
  ActivityTypeEnum.vipMonth, // 月返现
  ActivityTypeEnum.vipMonthBonus, // 月奖金
];
export type GClassNameListItemProps = {
  name: string;
  gclass: gclassEnum;
  sort?: string;
  isShowHot?: number;
  urlKey: string;
};

export const NavsIconMap = {
  [NavsClickNewType.home]: "lobby",
  [NavsClickNewType.gclass]: {
    [gclassEnum.original]: "orignals",
    [gclassEnum.special]: "special",
    [gclassEnum.slots]: "slots",
    [gclassEnum.live]: "live",
    [gclassEnum.shows]: "show",
  },
  [NavsClickNewType.maker_list]: "providers",
};

export const gclass_name_list: GClassNameListItemProps[] = [
  {
    name: "bet.originals",
    gclass: gclassEnum.original,
    urlKey: "Original",
  },
  {
    name: "bet.casual",
    gclass: gclassEnum.special,
    sort: "3",
    urlKey: "Special",
  },
  {
    name: "bet.slots",
    gclass: gclassEnum.slots,
    sort: "1",
    urlKey: "Slots",
  },
  {
    name: "bet.livecasino",
    gclass: gclassEnum.live,
    sort: "2",
    urlKey: "Lives",
  },
  {
    name: "bet.sports",
    gclass: gclassEnum.sport,
    sort: "5",
    isShowHot: 0,
    urlKey: "Sports",
  },
  {
    name: "bet.liveshow",
    gclass: gclassEnum.shows,
    sort: "4",
    urlKey: "Shows",
  },
  {
    name: "bet.lottery",
    gclass: gclassEnum.lottery,
    sort: "6",
    urlKey: "Lottery",
  },
] as const;

export const filterLoginTargetsState = [
  {
    click_params: "SuperValueGift",
    atype: ActivityTypeEnum.superValueGiftBox,
    status: false,
  },
  {
    click_params: "ActivityIframe-13",
    atype: ActivityTypeEnum.firstDeposit,
    status: false,
  },
  {
    click_params: "ActivityIframe-80",
    atype: ActivityTypeEnum.sevenNewTask,
    status: false,
  },
  {
    click_params: "NewbieWheel",
    atype: ActivityTypeEnum.newbieWheel,
    status: false,
  },
  {
    click_params: "ActivityIframe-94",
    atype: ActivityTypeEnum.dailyLossBack,
    status: false,
  },
  {
    click_params: "ActivityIframe-19",
    atype: ActivityTypeEnum.reliefFund3,
    status: false,
  },
  {
    click_params: "ActivityIframe-47",
    atype: ActivityTypeEnum.newCheckIn,
    status: false,
  },
  {
    click_params: "ActivityIframe-93",
    atype: ActivityTypeEnum.dailyCashbackExperience,
    status: false,
  },
  {
    click_params: "AppDownloadActivity",
    atype: ActivityTypeEnum.appdownload,
    status: false,
  },
];

export const filterNoLoginTargetsState = [
  {
    click_params: "ActivityIframe-13",
    atype: ActivityTypeEnum.firstDeposit,
    status: true,
  },
];

/** 奖金中心未登录跳转路由 */
export const BONUS_CENTER_NO_LOGIN_ROUTE_PATH = "/register";
